import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

const EASY_SELLER = 'easy';

const hasSellerEasy = (seller: string) => {
  return seller.toLowerCase() === EASY_SELLER;
};

const itemIsMarketplace = (lineItem: CartLineItem) => {
  const variant = lineItem?.variant;
  const isMarketplace = variant?.attributes?.some(
    (attr) => attr.name === 'isMarketplace' && attr.value
  );

  return isMarketplace;
};

const itemIsIntangible = (lineItem: CartLineItem) => {
  return lineItem?.productType?.key === 'intangibles';
};

const containsEasyProduct = (cart: Partial<Cart>) => {
  return cart?.lineItems?.some((item) => {
    const variant = item?.variant;
    const sellers = variant?.attributes?.find(
      (attr) => attr.name === 'sellers'
    );

    const departmentId = variant?.attributes?.find(
      (attr) => attr.name === 'departmentId'
    )?.value;

    const seller = Array.isArray(sellers?.value) ? sellers.value[0] : '';
    const isEasySeller = hasSellerEasy(seller);
    const isMarketplace = itemIsMarketplace(item);
    const isEasyDepartment = departmentId === '801';

    return isMarketplace && isEasyDepartment && isEasySeller;
  });
};

const containsIntangibleMarketplace = (cart: Partial<Cart>) => {
  return cart?.lineItems?.some((item) => {
    const isMarketplace = itemIsMarketplace(item);
    const isIntangible = itemIsIntangible(item);

    return isMarketplace && isIntangible;
  });
};

const containsIntangibleParis = (cart: Partial<Cart>) => {
  return cart?.lineItems?.some((item) => {
    const isMarketplace = itemIsMarketplace(item);
    const isIntangible = itemIsIntangible(item);

    return !isMarketplace && isIntangible;
  });
};

const containsIntangible = (cart: Partial<Cart>) => {
  const hasIntangibleMarketplace = containsIntangibleMarketplace(cart);
  const hasIntangibleParis = containsIntangibleParis(cart);
  const hasIntangible = hasIntangibleMarketplace || hasIntangibleParis;
  return hasIntangible;
};

const containsMarketPlace = (cart: Cart) => {
  return cart?.lineItems?.some((item) => {
    return itemIsMarketplace(item);
  });
};

export {
  containsEasyProduct,
  containsIntangible,
  containsIntangibleMarketplace,
  containsIntangibleParis,
  containsMarketPlace
};
